import { Button, Label, TextInput, Table, } from "flowbite-react";
import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import CustomSelect from "../hooks/CustomSelect";
import CustomSelectwithText from "../hooks/CustomSelectwithText";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useSidebar } from "../context/SidebarOpenContext";
import Breadcrumb from "../hooks/Breadcrumb";
import { RiInboxArchiveFill } from "react-icons/ri";
import { IoMdClose } from "react-icons/io";

function Editorder() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const Order_id = searchParams.get("id");
    const [selectedStyle, setselectedStyle] = useState('');
    const [selectedBuyer, setselectedBuyer] = useState('');
    const [selectedBoxing, setselectedBoxing] = useState('');
    const [Customer, setCustomer] = useState({});
    const [Colour, setColour] = useState({});
    const [Style, setStyle] = useState({});
    const [Marker, setMarker] = useState({});
    const [Input, setInput] = useState({ orderdate: "", total_piece: 0, cutorderno: "", pono: "", noofbales: "", delivery_date: "" });
    const today = new Date().toISOString().split('T')[0];
    const url = localStorage.getItem("url");
    const { isSidebarOpen } = useSidebar();
    useEffect(() => {
        fetchcustomer();
        fetchColour();
        fetchstyle();
        fetchmarker();
        fetchorder();
    }, []);

    const fetchorder = async () => {
        try {
            const response = await axios.get(`order/orders/${Order_id}`);
            const OrderData = response.data;
            setInput({
                orderdate: OrderData.order_date,
                total_piece: OrderData.total_piece,
                cutorderno: OrderData.cut_order_no,
                pono: OrderData.job_no,
                noofbales: OrderData.no_of_bales,
                delivery_date: OrderData.delivery_date,
                eopercentage: OrderData.eopercentage
            });
            setselectedBuyer(OrderData.buyer_id);
            setselectedBoxing(OrderData.boxing_type);
            setselectedStyle(OrderData.style_id);
            const orderSuborders = OrderData.suborders;

            const newRows = orderSuborders.map(suborder => ({
                colour: suborder.colour_id,
                selectedMarker: suborder.size_variant_quantity,
                size_variant_price: suborder.size_variant_price,
            }));

            const newTotals = {};
            orderSuborders.forEach((suborder, index) => {
                newTotals[index] = suborder.total_piece;
            });

            // Update state
            setRows(newRows);
            setTotals(newTotals);
            recalculateTotals(newRows);

        } catch (error) {
            console.error("Error fetching order data:", error);
        }
    };

    const fetchcustomer = async () => {
        try {
            const response = await axios.get("master/buyers");
            const CustomerData = response.data;
            setCustomer(CustomerData);
        } catch (error) {
            console.error("Error fetching customer data:", error);
        }
    };

    const fetchColour = async () => {
        try {
            const response = await axios.get("master/colours");
            const ColourData = response.data;
            setColour(ColourData);
        } catch (error) {
            console.error("Error fetching Colour data:", error);
        }
    };

    const fetchstyle = async () => {
        try {
            const response = await axios.get("master/styles");
            const StyleData = response.data;
            setStyle(StyleData);
        } catch (error) {
            console.error("Error fetching Style data:", error);
        }
    };

    const fetchmarker = async () => {
        try {
            const response = await axios.get("master/size_variants");
            const markerData = response.data;
            setMarker(markerData);
        } catch (error) {
            console.error("Error fetching Marker data:", error);
        }
    };

    const Style_options = Style.length > 0 ? Style.map(style => ({
        value: style.style_id,
        label: style.style_name,
    })) : [];


    const selectedstylevalue = Style.length > 0 && Style.find(item => item.style_id === selectedStyle);

    const sizeVariantType = selectedstylevalue ? selectedstylevalue.size_variant_type : null;

    const sizevariantOptions = Marker.length > 0
        ? Marker.filter(marker => marker.type === sizeVariantType)
            .map(marker => ({
                value: marker.size_id,
                label: marker.size
            }))
        : [];


    const Buyer_options = Customer.length > 0 ? Customer.map(customer => ({
        value: customer.customer_id,
        label: customer.customer_name,
    })) : [];

    const Colour_options = Colour.length > 0
        ? Colour.map(colour => ({
            value: colour.colour_id,
            label: colour.colour_name,
            imgSrc: colour.colour_image ? `${url}${colour.colour_image}` : null,
        }))
        : [];

const Boxing_options = [
  { label: "Single Boxing", value: "Single" },
  { label: "Group Boxing", value: "Group" },
];

    const onChangeValue = (e) => {
        const { name, value } = e.target;
        setInput((prev) => ({ ...prev, [name]: value }));
    }

    const EditOrder = async (event) => {
        event.preventDefault();


        if (
            !Input.orderdate.trim() ||
            !selectedBuyer ||
            !selectedBoxing ||
            !selectedStyle ||
            !Input.pono.trim() ||
            overallTotal <= 0 ||
            !Object.keys(combinedTotals).length ||
            !Array.isArray(rows) || rows.length === 0 ||
            rows.some(row => !row.colour || !Object.keys(row.selectedMarker).length || !row.size_variant_price) ||
            !Object.keys(totals).length ||
            !Input.cutorderno.trim() ||
            !Input.delivery_date.trim()
        ) {
            Swal.fire({
                icon: "error",
                text: "Please fill all required fields",
                timer: 2000,
                showConfirmButton: false,
            });
            return;
        }



        try {
            axios
                .put(`order/orders/${Order_id}`, {
                    order_date: Input.orderdate,
                    buyer_id: selectedBuyer,
                    boxing_type: selectedBoxing,
                    style_id: selectedStyle,
                    po_num: Input.pono,
                    total_piece: overallTotal,
                    total_size_variant_quantity: combinedTotals,
                    colour_with_size_variant_quantity: rows,
                    colour_wise_total_piece: totals,
                    cut_order_no: Input.cutorderno,
                    delivery_date: Input.delivery_date,
                    eopercentage: Input.eopercentage
                })
                .then((res) => {
                    if (res.data.success === 1) {
                        Swal.fire({
                            icon: "success",
                            text: "Order  Created",
                            type: "success",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                        navigate("/order");
                    } else if (res.data.success === 2) {
                        Swal.fire({
                            icon: "error",
                            text: "Cut Order Number already exists...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: "Server Problem. Please Try Again...",
                            type: "error",
                            timer: 2000,
                            showConfirmButton: false,
                        });
                    }
                    return;
                });
        } catch (error) {
            throw error;
        }
    };



    const breadcrumbItems = [
        {
            href: "/order",
            label: "Order",
            icon: (
                <RiInboxArchiveFill className="flex-shrink-0 w-5 h-5  " />

            ),
        },
        {
            label: "Edit Order",
        },

    ];

    const [rows, setRows] = useState([
        { colour: "", selectedMarker: {}, size_variant_price: "" },

    ]);
    const [totals, setTotals] = useState({});
    const [overallTotal, setOverallTotal] = useState(0);
    const [combinedTotals, setCombinedTotals] = useState({});

    const addRow = () => {
        const newRow = { colour: "", selectedMarker: {}, size_variant_price: "" };
        setRows([...rows, newRow]);
    };

    const deleteRow = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);

        const updatedTotals = { ...totals };
        delete updatedTotals[index];
        setTotals(updatedTotals);

        recalculateTotals(updatedRows);
    };

    const handleColourChange = (index, value) => {
        setRows((prevRows) => {
            const isDuplicate = prevRows.some(
                (row, i) => i !== index && row.colour === value
            );
            if (isDuplicate) {
                return prevRows;
            }
            return prevRows.map((row, i) =>
                i === index ? { ...row, colour: value } : row
            );
        });
    };

    const handlePriceChange = (rowIndex, sizeId, value) => {
        if (value === "" || /^[0-9]*$/.test(value)) {
            setRows((prevRows) =>
                prevRows.map((row, i) => {
                    if (i !== rowIndex) return row;

                    return {
                        ...row,
                        size_variant_price: {
                            ...row.size_variant_price,
                            [sizeId]: value,
                        },
                    };
                })
            );
        }
    };


    const handleMarkerChange = (index, selectedMarker) => {
        setRows((prevRows) =>
            prevRows.map((row, i) => {
                if (i !== index) return row;

                // Initialize empty prices for selected sizes
                const newPrices = {};
                Object.keys(selectedMarker).forEach((sizeId) => {
                    newPrices[sizeId] = row.size_variant_price?.[sizeId] || "";
                });

                return {
                    ...row,
                    selectedMarker,
                    size_variant_price: newPrices,
                };
            })
        );
    };

    const recalculateTotals = (rows) => {
        const combined = {};
        let overall = 0;

        rows.forEach((row) => {
            Object.entries(row.selectedMarker).forEach(([key, value]) => {
                const numericValue = parseInt(value || 0, 10);
                if (!combined[key]) {
                    combined[key] = 0;
                }
                combined[key] += numericValue;
                overall += numericValue;
            });
        });

        setCombinedTotals(combined);
        setOverallTotal(overall);
    };


    return (
        <div className={` ${isSidebarOpen ? "p-4 sm:ml-64 bg-content-bg min-h-screen " : "p-4  bg-content-bg min-h-screen"}  `} >
            <div className="p-4 rounded-lg dark:border-gray-700  mt-14  h-full">
                <div className="p-4 rounded-lg shadow bg-white ">
                    <div className="space-y-6">
                        <Breadcrumb items={breadcrumbItems} />
                        <h3 className="text-xl font-medium text-sidebar-color dark:text-white">
                            Edit Order
                        </h3>
                        <form method="post">
                            <div className="flex gap-4">
                                <div className="w-1/2">
                                    <div className="mb-2 block  ">
                                        <Label htmlFor="password" value="Order Date" />
                                    </div>
                                    <TextInput
                                        name="orderdate"
                                        type="date"
                                        required
                                        autoComplete="off"
                                        onChange={onChangeValue}
                                        max={today}
                                        value={Input.orderdate}
                                    />
                                </div>
                                <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="buyer" value="Buyer Name" />
                                    </div>
                                    <CustomSelect
                                        value={selectedBuyer}
                                        onChange={(selected) => {
                                            setselectedBuyer(selected);
                                        }}
                                        options={Buyer_options}
                                        placeholder="Select an option"
                                        id="buyer-select"
                                        name="buyerSelect"
                                    />
                                </div>
                            </div>
                            <div className="flex gap-4 mt-4">

                                <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="buyer" value="Style" />
                                    </div>
                                    <CustomSelect
                                        value={selectedStyle}
                                        onChange={setselectedStyle}
                                        options={Style_options}
                                        placeholder="Select an style"
                                        id="style-select"
                                        name="styleSelect"
                                    />
                                </div>
                                <div className="w-1/2">
                                    <div className="mb-2 block  ">
                                        <Label htmlFor="jobno" value="PO Number" />
                                    </div>
                                    <TextInput
                                        name="pono"
                                        type="text"
                                        required
                                        autoComplete="off"
                                        onChange={onChangeValue}
                                        value={Input.pono}
                                    />
                                </div>
                            </div>
                            <div className="flex gap-4 mt-4">

                                <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="cutorderno" value="Order Number" />
                                    </div>
                                    <TextInput
                                        name="cutorderno"
                                        type="text"
                                        required
                                        autoComplete="off"
                                        value={Input.cutorderno}
                                        readonly
                                    />
                                </div>
                                <div className="w-1/2">
                                    <div className="mb-2 block  ">
                                        <Label htmlFor="marker" value="Delivery date" />
                                    </div>
                                    <TextInput
                                        name="delivery_date"
                                        type="date"
                                        autoComplete="off"
                                        onChange={(e) => onChangeValue(e)}
                                        value={Input.delivery_date}
                                    />
                                </div>
                            </div>

                            <div className="flex gap-4 mt-4">

                                <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="Excess order percentage" value="Excess order percentage" />
                                    </div>
                                    <TextInput
                                        value={Input.eopercentage}
                                        name="eopercentage"
                                        type="number"
                                        required
                                        autoComplete="off"
                                        onChange={onChangeValue}
                                    />
                                </div>

                                 <div className="w-1/2">
                                    <div className="mb-2 block">
                                        <Label htmlFor="buyer" value="Boxing Type" />
                                    </div>
                                    <CustomSelect
                                        value={selectedBoxing}
                                        onChange={setselectedBoxing}
                                        options={Boxing_options}
                                        placeholder="Select an Boxing"
                                        id="style-select"
                                        name="styleSelect"
                                    />
                                </div>

                            </div>

                            <div className=" flex items-center pt-4">
                                <h3 className="text-lg font-medium text-sidebar-color dark:text-white mr-2">
                                    Selected Quantity Based on Colour
                                </h3>
                                <Button className="bg-sidebar-color text-white" size="xs" onClick={addRow}> Add</Button>
                            </div>
                            <div className="overflow-x-auto "  >
                                <Table hoverable className="border  mt-4   ">
                                    <Table.Head className="border">
                                        <Table.HeadCell className="border min-w-[200px]">
                                            Colour
                                        </Table.HeadCell>
                                        <Table.HeadCell className="border min-w-[350px]">
                                            Selected Quantity
                                        </Table.HeadCell>
                                        <Table.HeadCell className="border ">
                                            Total
                                        </Table.HeadCell>
                                        <Table.HeadCell className="border ">
                                            Price
                                        </Table.HeadCell>
                                        <Table.HeadCell className="border">
                                            Delete
                                        </Table.HeadCell>
                                    </Table.Head>
                                    <Table.Body className="divide-y border">
                                        {rows.map((row, index) => (
                                            <Table.Row key={index} className="border ">
                                                {/* Colour Select */}
                                                <Table.Cell className="border ">
                                                    <CustomSelect
                                                        value={row.colour}
                                                        onChange={(selectedOptions) => handleColourChange(index, selectedOptions)}
                                                        options={Colour_options}
                                                        placeholder="Select a colour"
                                                        id={`colour-${index}`}
                                                        name={`colour-${index}`}
                                                        includeImage={true}
                                                    />
                                                </Table.Cell>

                                                {/* Marker / Size Variant Selector */}
                                                <Table.Cell className="border w-[150px]">
                                                    <CustomSelectwithText
                                                        value={row.selectedMarker}
                                                        onChange={(selectedOptions) => handleMarkerChange(index, selectedOptions)}
                                                        options={sizevariantOptions}
                                                        id={`marker-${index}`}
                                                        name={`marker-${index}`}
                                                        // className="w-[120px]"
                                                    />
                                                </Table.Cell>

                                                {/* Total Piece Column */}
                                                <Table.Cell className="border text-center">
                                                    {totals[index] || 0}
                                                </Table.Cell>

                                                {/* Dynamic Size-Wise Price Inputs */}
                                                {/* PRICE column similar to SELECTED QUANTITY style */}
                                                <Table.Cell className="border text-center">
                                                    <div className="grid grid-cols-3 gap-1  justify-center">
                                                        {row.selectedMarker &&
                                                            Object.entries(row.selectedMarker).map(([sizeId, qty]) => (
                                                                <div key={`${index}-${sizeId}`} className="flex flex-col items-start w-[150px] mb-1">
                                                                    <span className="text-sm font-medium">
  {sizevariantOptions.find((opt) => opt.value.toString() === sizeId.split("_")[0])?.label || sizeId.split("_")[0]}
</span>


                                                                    <TextInput
                                                                        value={row.size_variant_price?.[sizeId] || ""}
                                                                        id={`price-${index}-${sizeId}`}
                                                                        name={`price-${index}-${sizeId}`}
                                                                        type="text"
                                                                        className="w-16"
                                                                        autoComplete="off"
                                                                        onChange={(e) => handlePriceChange(index, sizeId, e.target.value)}
                                                                    />
                                                                </div>
                                                            ))}
                                                    </div>
                                                </Table.Cell>

                                                {/* Delete Row Icon */}
                                                <Table.Cell className="border text-center">
                                                    <IoMdClose
                                                        size={24}
                                                        style={{
                                                            color: rows.length === 1 ? "grey" : "red",
                                                            cursor: rows.length === 1 ? "not-allowed" : "pointer",
                                                        }}
                                                        onClick={rows.length === 1 ? null : () => deleteRow(index)}
                                                    />
                                                </Table.Cell>
                                            </Table.Row>
                                        ))}
                                    </Table.Body>

                                </Table>

                                {Object.keys(combinedTotals).length > 0 ? (
                                    <div className="overflow-x-auto mt-4">
                                        <Table className="border">
                                            <Table.Head className="border">
                                                <Table.HeadCell className="border">Size</Table.HeadCell>
                                                {Object.keys(combinedTotals).map((key) => (
                                                    <Table.HeadCell key={key} className="border">
                                                        {sizevariantOptions.find(option => option.value === parseInt(key))?.label || key}
                                                    </Table.HeadCell>
                                                ))}
                                                <Table.HeadCell className="border">Total</Table.HeadCell>
                                            </Table.Head>
                                            <Table.Body className="divide-y">
                                                <Table.Row className="bg-white dark:border-gray-700 dark:bg-gray-800">
                                                    <Table.Cell className="border whitespace-nowrap font-medium text-gray-900 dark:text-white">
                                                        Quantity
                                                    </Table.Cell>
                                                    {Object.keys(combinedTotals).map((key) => (
                                                        <Table.Cell key={key} className="border">
                                                            {combinedTotals[key] || 0}
                                                        </Table.Cell>
                                                    ))}
                                                    <Table.Cell className="border">
                                                        {overallTotal}
                                                    </Table.Cell>
                                                </Table.Row>
                                            </Table.Body>
                                        </Table>
                                    </div>
                                ) : (
                                    <div className="overflow-x-auto mt-4  pt-[100px]  ">
                                    </div>
                                )}
                            </div>
                            <div className="flex justify-center gap-4 pt-4">
                                <Button
                                    className="bg-icon-color text-sidebar-color drop-shadow-md font-bold"
                                    type="button"
                                    onClick={EditOrder}
                                >
                                    {"Submit"}
                                </Button>
                            </div>
                        </form>
                    </div>
                </div>
            </div >
        </div >
    );
}

export default Editorder;
